import { useRoutes } from "react-router";
import AuthRoutes from "./AuthRoutes";
// import View from "../pages/Main/Viewcontent";
// import MainRoutesWithProtection from "./MainRoutes";
// import ProtectedRoute from "../Protected Routes/ProtectedRoute";
import MainRoutes from "./MainRoutes";

export default function Router() {
  return useRoutes([
    MainRoutes,
    AuthRoutes,
    // {
    //   path: "/View",
    //   element: (
    //     <ProtectedRoute>
    //       <View />
    //     </ProtectedRoute>
    //   ),
    // },
  ]);
}
